import { AlignmentType, Table, TableRow, WidthType } from 'docx'
import {
  createBoldParagraph,
  createParagraph,
  createTableCell,
  DEFAULT_TABLE_MARGINS,
} from '../docxFunctions'
import { ru_ending } from '@/lib/strUtils'

export function createCellsInRow(row) {
  try {
    return [
      createTableCell({
        children: [createParagraph(row.groupName.value ?? '-', {}, {}, 20)],
      }),
      createTableCell({
        children: [
          createParagraph(
            row.mnn.value || '',
            { alignment: AlignmentType.CENTER },
            {},
            20
          ),
        ],
      }),
      createTableCell({
        children: [
          createParagraph(
            row.patientPopulation.value || '-',
            { alignment: AlignmentType.CENTER },
            {},
            20
          ),
        ],
      }),
    ]
  } catch (err) {
    throw new Error(`'<не определёно>'}: ${err}`)
  }
}

function createHeaderCellsInRow(row) {
  return [
    createTableCell({
      children: [
        createBoldParagraph(row.kei, { alignment: AlignmentType.CENTER }, 20),
      ],
    }),
    createTableCell({
      children: [
        createBoldParagraph(
          row.result,
          { alignment: AlignmentType.CENTER },
          20
        ),
      ],
    }),
    createTableCell({
      children: [
        createBoldParagraph(row.score, { alignment: AlignmentType.CENTER }, 20),
      ],
    }),
  ]
}

export function createTableHeaderRows() {
  return [
    new TableRow({
      children: createHeaderCellsInRow({
        kei: 'Клинико-экономическое исследование (анализ влияния на бюджет)',
        result: 'Результат оценки (процент отклонения)',
        score: 'Оценка (баллов)',
      }),
    }),
  ]
}

export function createAssessmentTable(tableData, economic) {
  const createText = function (indicators, text = '') {
    let percentDeviation = 0
    indicators.forEach(element => {
      if (Number(element.percentDeviation) < 0) {
        if (Number(percentDeviation) === 0)
          percentDeviation = element.percentDeviation
        if (Number(percentDeviation) > Number(element.percentDeviation)) {
          percentDeviation = element.percentDeviation
        }
      }
      if (
        Number(percentDeviation) >= 0 &&
        Number(percentDeviation) < Number(element.percentDeviation)
      )
        percentDeviation = element.percentDeviation
    })

    return text + percentDeviation.toString().replace('.', ',') + '%'
  }
  const createParagrapKeiExps = function () {
    const outPar = []
    economic.forEach((item, index) => {
      outPar.push(
        createParagraph(
          createText(item.indicatorsKei, `КЭИ ${index + 1}: `),
          {},
          {},
          20
        )
      )
    })
    return outPar
  }

  const createParagrapAvbExps = function () {
    const outPar = []
    economic.forEach((item, index) => {
      outPar.push(
        createParagraph(
          createText(item.indicatorsAvb, `АВБ ${index + 1}: `),
          {},
          {},
          20
        )
      )
    })
    return outPar
  }
  const createParagrapAvbScore = function () {
    const outPar = []
    economic.forEach(item => {
      outPar.push(createParagraph(item.scoreAvb || '0', {}, {}, 20))
    })
    return outPar
  }
  const createParagrapKeiScore = function () {
    const outPar = []
    economic.forEach(item => {
      outPar.push(createParagraph(item.scoreKei || '0', {}, {}, 20))
    })
    return outPar
  }
  try {
    return new Table({
      alignment: AlignmentType.JUSTIFIED,
      margins: DEFAULT_TABLE_MARGINS,
      width: {
        size: 100,
        type: WidthType.PERCENTAGE,
      },
      rows: [
        ...createTableHeaderRows(),
        new TableRow({
          children: [
            createTableCell({
              children: [
                createParagraph(
                  'Клинико-экономическое исследование',
                  {},
                  {},
                  20
                ),
              ],
            }),
            createTableCell({
              children: [...createParagrapKeiExps()],
            }),
            createTableCell({
              children: [...createParagrapKeiScore()],
            }),
          ],
        }),
        new TableRow({
          children: [
            createTableCell({
              children: [
                createParagraph('Анализ влияния на бюджет', {}, {}, 20),
              ],
            }),
            createTableCell({
              children: [...createParagrapAvbExps()],
            }),
            createTableCell({
              children: [...createParagrapAvbScore()],
            }),
          ],
        }),
        new TableRow({
          children: [
            createTableCell({
              children: [
                createParagraph(
                  'Итоговая оценка по результатам оценки экономических последствий применения лекарственного препарата по показанию',
                  {},
                  {},
                  20
                ),
              ],
              columnSpan: 2,
            }),
            createTableCell({
              children: [
                createParagraph(
                  '+' +
                    ru_ending(tableData?.resultScore, [
                      'балл',
                      'балла',
                      'баллов',
                    ])
                ),
              ],
            }),
          ],
        }),
      ],
    })
  } catch (err) {
    throw new Error(
      `[createAssessmentTable] Ошибка построения таблицы assessment: ${err.message}`
    )
  }
}
